<ng-container *ngIf="vm$ | async as vm">

    <div
        class="uni-pagination"
        *ngIf="vm.numberOfPages > 1"
    >
        <div class="uni-pagination__pages">
            <uni-pagination-nav>
                <ng-container *ngFor="let page of vm.pagesNav">
                    <ng-container *ngIf="page !== '...'">
                        <uni-button
                            [style]="'secondary'"
                            (click)="selectPage(page)"
                            [class.active]="vm.currentPage === page"
                        >
                            {{ page }}
                        </uni-button>
                    </ng-container>
                    <ng-container *ngIf="page === '...'">
                        <div class="pagination-button-separator">{{page}}</div>
                    </ng-container>

                </ng-container>
            </uni-pagination-nav>

            <uni-pagination-controllers
                *ngIf="vm.numberOfPages > 1"
                [currentPage]="vm.currentPage"
                [pagesAmount]="vm.numberOfPages"
                (controllerAction)="changePageByOne($event, vm.currentPage, vm.numberOfPages)"
            ></uni-pagination-controllers>
        </div>

        <form
            #form="ngForm"
            class="pagination-form"
        >
        <label>
            {{vm.goToPageLabel}}
        </label>
        <input
          type="number"
          required
          min="1"
          [ngModel]
          [placeholder]="vm.pageNumberLabel"
          name="page"
          keyPattern="number"
          (paste)="onPaste($event)"
          uniInput
        >
        <uni-button
          type="submit"
          [style]="'secondary'"
          [disabled]="form.invalid"
          (click)="onSubmit(form)"
        >
          {{ vm.goLabel }}
        </uni-button>
      
      </form>

    </div>


</ng-container>